import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 14654BFB-0D87-43E0-8A47-7CF1EE1CF418
 * name power-socket-de
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-de.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketDeIcon = createSvgIcon(<><path d="M4.22 2A2.22 2.22 0 0 0 2 4.22V19.78C2 21 3 22 4.22 22H19.78A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M11 4.07V6H13V4.07A8 8 0 0 1 20 12A8 8 0 0 1 13 19.93V18H11V19.93A8 8 0 0 1 4 12A8 8 0 0 1 11 4.07M7.5 10.5A1.5 1.5 0 0 0 6 12C6 12.83 6.66 13.5 7.5 13.5A1.5 1.5 0 0 0 9 12A1.5 1.5 0 0 0 7.5 10.5M16.5 10.5A1.5 1.5 0 0 0 15 12A1.5 1.5 0 0 0 16.5 13.5A1.5 1.5 0 0 0 18 12A1.5 1.5 0 0 0 16.5 10.5Z" /></>, 'PowerSocketDeIcon');
export default PowerSocketDeIcon